module.exports = __webpack_public_path__ + "img/BUY.efb8785d.svg";